var three = require("three/three.min");

module.exports = new three.Scene();